<template>
    <div class="setting-advanced-tag">
        <div class="module-item-style">
            <div class="module-item-title">标签</div>
            <div class="module-item-tips">通过标签 ，客服可对访客进行分类，以方便后续的整理和分析</div>
            <div class="tag-add-btn">
                <div class="wl-btn" @click="addTag"><i class="el-icon-plus"></i>添加标签</div>
            </div>
            <div class="table-box">
                <el-table
                        :data="tableData"
                        stripe
                        :header-cell-style="{background:'#f2f2f2'}"
                        style="border: 1px solid #ebeef5;">
                    <el-table-column
                            v-for="(tHead, thIndex) in tableHead"
                            v-if="!tHead.operate"
                            :key="'th-' + thIndex"
                            :width="tHead.width"
                            :prop="tHead.value"
                            :label="tHead.label">
                        <template slot-scope="scope">
                            <span class="tag" :class="'tc-'+scope.row.tagColor" v-if="tHead.value == 'tagName'">{{scope.row[tHead.value]}}</span>
                            <span v-else>{{scope.row[tHead.value]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-else :label="tHead.label" :width="tHead.width">
                        <template slot-scope="scope">
                            <button class="tb-btn" :class="'tb-btn-'+handler.type"
                                    v-for="(handler, index) in tableHandler"
                                    :key="'handler'+ index"
                                    @click="handleButton(handler.methods, scope.row)">{{handler.label}}
                            </button>
                        </template>
                    </el-table-column>
                </el-table>

                <!--    分页-->

                <pagenations
                        :total="total"
                        :size="pageSize"
                        @pageHandler="pageOperate">
                </pagenations>
            </div>
        </div>

        <el-dialog
                :title="tagDialogTitle"
                width="450px"
                class="tag-dialog"
                :visible.sync="dialogFormVisible">
            <div class="tag-content-container">
                <div class="tag-color-box">
                    <div class="tag-color-item" v-for="(tagColor,index ) in renderTagColor"
                         @click="selectColor(tagColor,index)"
                         :class="['tc-'+tagColor.label,activeTagColor == index ? 'actived' : '']" :key="index"></div>
                </div>
                <div class="tag-input-box">
                    <div class="tag-input-label"><span>*</span>标签名称：</div>
                    <div>
                        <el-input v-model="tagForm.tagName" placeholder="请输入内容"></el-input>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitData">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pagenations from '@/components/pagenations/pagenations'

    export default {
        name: 'setting-advanced-tag',
        components: {
            pagenations
        },
        data() {
            return {
                tagDialogTitle: '添加标签',
                dialogFormVisible: false,
                dialogType:'add',
                tagId:'',
                activeTagColor: '0',
                renderTagColor: [
                    {label: 'goldenrod', value: '#ffb652'},
                    {label: 'sienna', value: '#b59177'},
                    {label: 'seagreen', value: '#6fd048'},
                    {label: 'navyblue', value: '#9264cd'},
                    {label: 'orchid', value: '#fc7cb3'},
                    {label: 'tomato', value: '#ff8947'},
                    {label: 'green', value: '#00ce7d'},
                    {label: 'blue', value: '#4ca0ff'},
                    {label: 'red', value: '#ff5c5e'},
                    {label: 'gray', value: '#707070'},
                ],
                tagForm: {
                    tagColor: '',
                    tagName: ''
                },
                currentPage: 1,
                pageSize: 10,
                tableHandler: [
                    {label: "编辑", type: 'edit', methods: 'editMethods'},
                    {label: "删除", type: 'del', methods: 'delMethods'},
                ],
                tableData: [],
                tableHead: [
                    {
                        label: '标签',
                        value: 'tagName',
                        operate: false
                    }, {
                        label: '使用次数',
                        value: 'userNum',
                        operate: false
                    }, {
                        label: '操作',
                        value: '',
                        width: '160',
                        operate: true,
                    }
                ],
                total: 0
            }
        },
        created() {
            this.getTagData()
        },
        mounted() {

        },
        methods: {
            handleButton(methods, row) {
                if (methods == "delMethods") {
                    this.$confirm('将要进行删除操作, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$http.delTagAPI({
                            tagId: row.tagId
                        }).then(res => {
                            if (res.status == 1) {
                                this.getTagData()
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                })
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                })
                            }
                        })
                    }).catch(() => {

                    });
                } else {
                    this.editTag(row)
                }

            },
            pageOperate(val) {
                if (val.type == 'currentChange') {
                    this.currentPage = val.val
                } else if (val.type == 'sizeChange') {
                    this.pageSize = val.val
                }
                this.getTagData()
            },
            getTagData() {
                this.$http.getTagListAPI({
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }).then(res => {
                    if (res.status == 1) {
                        this.tableData = res.data
                        this.total = res.total
                    }
                })
            },
            addTag() {
                this.dialogType = 'add'
                this.activeTagColor = '0'
                this.tagForm = {
                    tagColor: this.renderTagColor[0].label,
                    tagName: ''
                }
                this.tagDialogTitle = '添加标签'
                this.dialogFormVisible = true

            },
            editTag(item) {
                this.tagForm = {
                    tagColor: item.tagColor,
                    tagName: item.tagName
                }
                this.renderTagColor.map((colorItem, i) => {
                    if(colorItem.label == item.tagColor){
                        this.activeTagColor = i
                    }
                })
                this.tagId = item.tagId
                this.dialogType = 'edit'
                this.tagDialogTitle = '编辑标签'
                this.dialogFormVisible = true
            },
            submitData() {
                if (this.$utils.u_isEmpty(this.tagForm.tagName)) {
                    this.$message({
                        message: '标签名不能为空',
                        type: 'error',
                    })
                    return false

                }
                if(this.dialogType == 'add'){
                    this.$http.addTagAPI(this.tagForm).then(res => {
                        if (res.status == 1) {
                            this.getTagData()
                            this.dialogFormVisible = false
                            this.$message({
                                message: res.msg,
                                type: 'success',
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                            })
                        }
                    })
                }else if(this.dialogType == 'edit'){
                    let editPost = this.tagForm
                    editPost.tagId = this.tagId
                    this.$http.editTagAPI(editPost).then(res => {
                        if (res.status == 1) {
                            this.getTagData()
                            this.dialogFormVisible = false
                            this.$message({
                                message: res.msg,
                                type: 'success',
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                            })
                        }
                    })
                }
            },
            selectColor(item, index) {
                this.tagForm.tagColor = item.label
                this.activeTagColor = index
            }
        }
    }
</script>

<style lang="scss">
    .setting-advanced-tag {
        .tag-add-btn {
            padding: 10px 0;

            i {
                font-weight: bold;
                margin-right: 3px;
            }
        }

        .tag-dialog {
            .tag-content-container {
                .tag-color-box {
                    display: flex;
                    justify-content: center;
                    padding: 0 0 30px;

                    .tag-color-item {
                        width: 25px;
                        height: 25px;
                        border-radius: 50%;
                        margin-right: 8px;
                        cursor: pointer;

                        &.tc-goldenrod {
                            $color: #ffb652;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;
                        }

                        &.tc-sienna {
                            $color: #b59177;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-seagreen {
                            $color: #6fd048;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-navyblue {
                            $color: #9264cd;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-orchid {
                            $color: #fc7cb3;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-tomato {
                            $color: #ff8947;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-green {
                            $color: #00ce7d;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-blue {
                            $color: #4ca0ff;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-red {
                            $color: #ff5c5e;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.tc-gray {
                            $color: #707070;
                            background: transparent;
                            color: $color;
                            border: 2px solid $color;

                            .fa {
                                background: $color;
                            }
                        }

                        &.actived {
                            border-width: 8px;
                        }
                    }
                }

                .tag-input-box {
                    display: flex;
                    align-items: center;

                    .tag-input-label {
                        font-size: 12px;
                        color: #333;

                        span {
                            color: #FF4E00;
                            padding-right: 5px;
                            line-height: 40px;
                        }
                    }
                }
            }
        }
    }
</style>
